<div class="vota-auth-layout w-full h-full">
  <router-outlet></router-outlet>
</div>
